import { createSelector } from "@reduxjs/toolkit";
import { selectMaxSeatCountForEvent } from "store/rooms";
import { selectMaxInTable } from "modules/company/redux/selectors";

export const selectMaxUsersPerTable = createSelector(
  selectMaxInTable,
  selectMaxSeatCountForEvent,
  (maxInTableFromPlan, maxSeatCount) => {
    if (maxInTableFromPlan) {
      return Math.min(maxSeatCount, maxInTableFromPlan);
    }
    return maxSeatCount;
  },
);
